import { Button } from '@peacecover/component';
import { ArrowLeft } from '@peacecover/icon';
import { useHandleHistoryBack } from '../../utils/useHandleHistoryBack';

const SceneContactUsPage = () => {
  const handleHistoryBack = useHandleHistoryBack();

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] bg-background-dark">
      <header className="px-[16px] py-[15px]">
        <button type="button" onClick={handleHistoryBack}>
          <ArrowLeft className="text-pure-white" />
        </button>
      </header>
      <div className="px-[24px] py-[10px] flex flex-col items-center gap-[14px] mt-[67px]">
        <h1 className="text-[26px] font-bold leading-[30px] text-main-dark-1 text-center">
          씬에서 이야기를 만들어갈
          <br />
          작가를 찾고 있어요!
        </h1>
        <p className="text-[15px] font-medium leading-[18px] text-main-dark-4 text-center">
          신청하기를 누르면 팬하트팀이 메일을 보내드려요
        </p>
      </div>
      <div className="py-[65px] relative mt-[57px]">
        <div
          className="absolute inset-0"
          style={{
            maskImage:
              'linear-gradient(90deg, rgba(0, 0, 0, 0.00) 2.26%, #000 50.13%, rgba(0, 0, 0, 0.00) 98.01%)',
            WebkitMaskImage:
              'linear-gradient(90deg, rgba(0, 0, 0, 0.00) 2.26%, #000 50.13%, rgba(0, 0, 0, 0.00) 98.01%)',
            maskSize: '100% 100%',
            maskRepeat: 'no-repeat'
          }}
        >
          <div className="absolute inset-0 bg-[linear-gradient(50deg,rgba(65,247,162,0.30)_-2.31%,rgba(92,61,250,0.30)_57.13%)]" />
          <div className="absolute left-0 top-0 right-0 h-[12px] flex justify-center items-center gap-[3px] bg-[linear-gradient(202deg,#45DCAE_30.46%,#5D3EFA_88.24%)]">
            {Array.from({ length: 60 }).map((_, index) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: key is used for animation
              <div key={index} className="w-[3px] h-[6px] bg-black rounded-[4px]" />
            ))}
          </div>
          <div className="absolute left-0 bottom-0 right-0 h-[12px] flex justify-center items-center gap-[3px] bg-[linear-gradient(202deg,#5D3EFA_18.07%,#45DCAE_87.89%)]">
            {Array.from({ length: 60 }).map((_, index) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: key is used for animation
              <div key={index} className="w-[3px] h-[6px] bg-black rounded-[4px]" />
            ))}
          </div>
        </div>
        <p className="relative z-10 mx-[36px] text-center text-[18px] font-semibold leading-[25px] text-pure-white">
          이야기를 만들거나 읽고 상상하는 걸<br />
          좋아하는 팬하트 유저라면 누구나 참여 가능
        </p>
      </div>
      <div className="fixed bottom-0 left-0 right-0 w-full px-[24px] pb-[calc(43px+env(safe-area-inset-bottom))]">
        <p className="text-[13px] text-main-dark-3 leading-[16px] mb-[22px] text-center">
          회원가입시 입력한 이메일주소로 메일이 전송됩니다
        </p>
        <Button
          size="large"
          className="w-full text-[17px] font-semibold bg-[linear-gradient(71deg,#45DCAE_18.48%,#5D3EFA_87.02%)]"
        >
          1초만에 신청하기
        </Button>
      </div>
    </div>
  );
};

export default SceneContactUsPage;
